import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fa9 } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Input/InputNumber.css'
import { numericFormatter } from 'react-number-format'

{/*
<InputNumber
    type={'amount'}
    theme={'light' |'dark'}
    ref={}
    number={} setNumber={}
    numberError={} setNumberError={}
    icon={<FontAwesomeIcon icon={fa9} />}
    placeholder={""}
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputTextDarkText: #49574b;
--inputTextSuccess: #435e48;
--inputTextError: #BB4040;
*/}

const InputNumber = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        inputNumberRef: inputNumberRef,
        numberValidation: (number) => numberValidation(number),
    }))

    const inputNumberRef = useRef(null)

    function onChange(number) {

        numberFormat(number)
        numberValidation(number)

    }

    function onFocus(number) {

        if (props.type === 'amount') {
            amountOnFocus(number)
        }

    }

    function onBlur(number) {

        if (props.type === 'amount') {
            amountOnBlur(number)
        }

    }

    function numberFormat(number) {

        var numberFormat = number.replace(/ /g, '')
        numberFormat = numericFormatter(numberFormat, { thousandSeparator: " " })
        if (numberFormat.includes('.')) {
            const numberParts = numberFormat.split('.')
            if (numberParts[1].length > 2) {
                numberFormat = numberParts[0] + '.' + numberParts[1].substring(0, 2)
            }
        }
        props.setNumber(numberFormat)

    }

    function numberValidation(number) {

        const numberRegex = /^[0-9. ]+$/
        if (props.nullable && number.length === 0) {
            props.setNumberError(null)
            return true
        }
        if (number && numberRegex.test(number)) {
            props.setNumberError(false)
            return true
        } else {
            props.setNumberError(true)
            return false
        }

    }

    function amountOnFocus(number) {

        props.setNumber(number.replace(/ €/g, ''))

    }

    function amountOnBlur(number) {

        if (number.length > 0) {
            props.setNumber(number + " €")
        }

    }

    return (

        <InputGroup>
            <InputGroup.Text className={['inputNumberIcon', props.theme === 'light' ? 'inputNumberIconLight' : 'inputNumberIconDark', props.numberError === false ? 'inputNumberIconSuccess' : props.numberError ? 'inputNumberIconError' : null].join(" ")}>
                {props.icon ? props.icon : <FontAwesomeIcon icon={fa9} />}
            </InputGroup.Text>
            <Form.Control
                ref={inputNumberRef}
                value={props.number}
                type={'text'}
                placeholder={props.placeholder}
                maxLength={props.maxLength}
                disabled={props.disabled}
                className={['inputNumber', props.theme === 'light' ? 'inputNumberLight' : 'inputNumberDark', props.numberError === false ? 'inputNumberSuccess' : props.numberError ? 'inputNumberError' : null].join(" ")}
                onChange={(e) => { props.setNumber(e.target.value); onChange(e.target.value) }}
                onFocus={(e) => onFocus(e.target.value)}
                onBlur={(e) => onBlur(e.target.value)}
                onKeyPress={(event) => props.onPressEnter && event.key === "Enter" ? props.onPressEnter() : null}
            />
        </InputGroup>

    )

})

export default InputNumber
